<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'NOTE.NOTES_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddNote">
          <button mat-raised-button type="button" class="btn btn-primary" (click)="addNote($event)">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'NOTE.ADD_NOTE' | translate }}</span>
          </button>
        </ng-template>
        <button
          mat-raised-button
          type="button"
          [matTooltip]="exporting ? 'Exporting...' : 'Export as CSV'"
          matTooltipPosition="above"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportNotesAsCSV($event)"
        >
          <i [ngClass]="exporting ? 'spinner-border spinner-border-sm' : 'fas fa-download'"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            mat-icon-button
            matSuffix
            type="button"
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          type="button"
          matTooltip="Search by Field/s"
          matTooltipPosition="above"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8 table-fit-content">
        <ng-container matColumnDef="pinned">
          <mat-header-cell *matHeaderCellDef>{{ 'NOTE.PINNED' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let note" class="d-flex align-items-center">
            <span
              inlineSVG="assets/media/svg/icons/Files/Pin.svg"
              [matTooltip]="note.pinned ? 'Unpin' : 'Pin'"
              matTooltipPosition="above"
              [class.svg-icon-warning]="note.pinned"
              class="svg-icon clickable"
              (click)="pinUnpinNote($event, note)"
            ></span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchPinned">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'NOTE.PINNED' | translate }}</mat-label>
              <mat-select #searchPinnedSelect>
                <mat-option value="">All</mat-option>
                <mat-option value="true">Pinned</mat-option>
                <mat-option value="false">Not Pinned</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="entities">
          <mat-header-cell *matHeaderCellDef>{{ 'NOTE.ENTITIES' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let note" class="gl-block">
            <div class="badged-list">
              <span *ngIf="!!note.entities?.length">{{ formatEntityValue(note.entities[0]) }}</span>
              <span
                *ngIf="note.entities?.length > 1"
                [matTooltip]="getEntitiesString(note.entities, 1)"
                matTooltipPosition="above"
                class="num-badge bg-light-primary text-primary"
              >
                {{ note.entities.length - 1 }}+
              </span>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEntity">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchEntityAutocomplete
              [label]="'NOTE.ENTITY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getEntityAutocomplete$"
              [optionFormatter]="formatEntityOption"
              [valueFormatter]="formatEntityValue"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="contacts">
          <mat-header-cell *matHeaderCellDef>{{ 'NOTE.CONTACTS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let note">
            <div class="badged-list">
              <span *ngIf="!!note.contacts?.length">{{ formatEntityValue(note.contacts[0]) }}</span>
              <span
                *ngIf="note.contacts?.length > 1"
                [matTooltip]="getEntitiesString(note.contacts, 1)"
                matTooltipPosition="above"
                class="num-badge bg-light-primary text-primary"
              >
                {{ note.contacts.length - 1 }}+
              </span>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchContact">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchContactAutocomplete
              [label]="'NOTE.CONTACT' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getContactAutocomplete$"
              [optionFormatter]="formatEntityValue"
              [valueFormatter]="formatEntityValue"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="subject">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'NOTE.SUBJECT' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let note" class="text-lines-2">{{ note.subject }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchSubject">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'NOTE.SUBJECT' | translate }}</mat-label>
              <input matInput #searchSubjectInput [placeholder]="'NOTE.SUBJECT' | translate" />
              <button
                *ngIf="searchSubjectInput.value"
                mat-icon-button
                matSuffix
                type="button"
                (click)="resetInput($event, searchSubjectInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'NOTE.DESCRIPTION' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let note" class="text-lines-2">{{ note.description }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDescription">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'NOTE.DESCRIPTION' | translate }}</mat-label>
              <input
                matInput
                #searchDescriptionInput
                [placeholder]="'NOTE.DESCRIPTION' | translate"
              />
              <button
                *ngIf="searchDescriptionInput.value"
                mat-icon-button
                matSuffix
                type="button"
                (click)="resetInput($event, searchDescriptionInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'NOTE.CREATED_ON' | translate
          }}</mat-header-cell>
          <mat-cell class="font-size-sm" *matCellDef="let note">{{
            note.created + ' UTC' | date : 'MMM dd, yyyy hh:mm a'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchStarted">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'NOTE.CREATED_ON' | translate }}</mat-label>
              <input
                matInput
                #searchStartedInput
                [matDatepicker]="searchStartedPicker"
                [placeholder]="'NOTE.CREATED_ON' | translate"
              />
              <mat-datepicker-toggle matSuffix [for]="searchStartedPicker"></mat-datepicker-toggle>
              <mat-datepicker #searchStartedPicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="created_by">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'NOTE.CREATED_BY' | translate
          }}</mat-header-cell>
          <mat-cell class="font-size-md" *matCellDef="let note">{{
            getUser(note.created_by) | getUserName
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchStartedBy">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchUserCreatedAutocomplete
              [label]="'NOTE.CREATED_BY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getUserAutocomplete$"
              [optionFormatter]="formatUserValue"
              [valueFormatter]="formatUserValue"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="updated">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'NOTE.UPDATED_ON' | translate
          }}</mat-header-cell>
          <mat-cell class="font-size-md" *matCellDef="let note">{{
            note.updated + ' UTC' | date : 'MMM dd, yyyy hh:mm a'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchUpdated">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'NOTE.UPDATED_ON' | translate }}</mat-label>
              <input
                matInput
                #searchUpdatedInput
                [matDatepicker]="searchUpdatedPicker"
                [placeholder]="'NOTE.UPDATED_ON' | translate"
              />
              <mat-datepicker-toggle matSuffix [for]="searchUpdatedPicker"></mat-datepicker-toggle>
              <mat-datepicker #searchUpdatedPicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="updated_by">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'NOTE.UPDATED_BY' | translate
          }}</mat-header-cell>
          <mat-cell class="font-size-md" *matCellDef="let note">{{
            getUser(note.updated_by) | getUserName
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchUpdatedBy">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchUserUpdatedAutocomplete
              [label]="'NOTE.UPDATED_BY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getUserAutocomplete$"
              [optionFormatter]="formatUserValue"
              [valueFormatter]="formatUserValue"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let note">
            <button
              type="button"
              [matTooltip]="'NOTE.FOLLOW_UP' | translate"
              matTooltipPosition="above"
              class="btn btn-sm btn-icon btn-light btn-hover-secondary symbol m-1"
              (click)="openFollowUpDialog($event, note)"
            >
              <span
                class="flaticon-calendar-with-a-clock-time-tools svg-icon svg-icon-md svg-icon-secondary"
              ></span>
              <span
                class="symbol-badge"
                [ngClass]="note.has_followup ? 'bg-danger' : 'bg-secondary'"
              ></span>
            </button>
            <ng-template ngxPermissionsOnly="canEditNote">
              <button
                type="button"
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Note"
                matTooltipPosition="above"
                class="btn btn-sm btn-icon btn-light btn-hover-primary m-1"
                (click)="updateNote($event, note)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canAddTask">
              <button
                type="button"
                [matTooltip]="'NOTE.CREATE_TASK' | translate"
                matTooltipPosition="above"
                class="btn btn-sm btn-icon btn-light btn-hover-warning m-1"
                (click)="createTask($event, note)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/Files/Clipboard-check.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div
        class="mat-table-message"
        *ngIf="!dataSource?.hasItems && !(dataSource?.loading$ | async)"
      >
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.loading$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
